import { registerNamespace } from '../i18n';
import heBooking from '../i18n/locales/he/booking.json';

/** Registers the Hebrew booking namespace (en/ar come with the on-demand extra locales). Safe to call more than once. */
export function registerBookingLocale(): void {
  registerNamespace('he', 'booking', heBooking);
}
